<!--
 * @Author: wbf
 * @LastEditTime: 2024-04-17 19:01:22
 * @Description: 修改密码
-->
<template>
  <div class="box">
    <NavBar :title="$t(`webapp.menus.${$route.meta.field}`)" :left-arrow="$route.meta.isShowArrow"
      @click-left="$router.back()" nav-bar-icon-color="#000" class="navbarSelf"></NavBar>

    <div class="box-title">
      <div v-if="$route.path == '/mupdatePassword'">
        <div>
          <Icon name="info-o" size="16" style="margin-right: 5px" />
          {{ updateMessageInfo }}
          ({{ alertDesc }})
        </div>
      </div>
      <div v-else>
        <div>
          <Icon name="info-o" size="16" style="margin-right: 5px" />
          {{ alertDesc }}
        </div>
      </div>
    </div>

    <Form @submit="onSubmit" class="vertical_self_form">
      <Field v-model="form.oldPassword" name="oldPassword" maxlength="32" :label="$t('base.password.old')"
        :placeholder="$t('base.password.old_placeholder')" :show-error-message="false" :scroll-to-error="true"
        :rules="[{ required: true }]" />
      <Field v-model="form.password" name="password" maxlength="32" :label="$t('base.password.new')"
        :placeholder="$t('base.password.new_placeholder')" :show-error-message="false" :scroll-to-error="true" :rules="[
          {
            required: true,
            message: $t('base.password.format_error'),
            validator: handlePass,
          },
        ]" />
      <Field v-model="form.confirmPassword" name="confirmPassword" :label="$t('base.password.new_confirm')"
        :placeholder="$t('base.password.new_confirm_placeholder')" :show-error-message="false" :scroll-to-error="true"
        :rules="[
          {
            required: true,
            message: $t('base.password.again_error'),
            validator: handleSurePass,
          },
        ]" />
      <!-- <Field
        v-model="form.code"
        name="code"
        label="验证码"
        placeholder="请输入验证码"
        :show-error-message="false"
        :scroll-to-error="true"
        :rules="[{ required: true }]"
      >
        <template #button>
          <img class="img" :src="validMaskImage" alt="" @click="getValidMask" />
        </template>
      </Field> -->

      <div class="rules" v-html="passwordRules"></div>

      <div style="margin-top: 30px">
        <Button round block type="info" native-type="submit">{{
          $t('base.btn.save')
          }}</Button>
      </div>
    </Form>
  </div>
</template>

<script>
  import { Field, Icon, Form, Button, NavBar } from 'vant'
  import { commonAPI } from '@/apis'
  import { toast } from '@/utils/toast'
  import { commonMethods } from '@/views/mViews/loginAuth/mixins/common'
  import { PasswordStrength } from '@/mixins/password-mobile'
  import { validateObject } from '@/utils/index'

  export default {
    name: 'Password',
    components: { Field, Icon, Form, Button, NavBar },
    mixins: [commonMethods, PasswordStrength],
    data() {
      return {
        form: {
          oldPassword: '',
          password: '',
          confirmPassword: '',
          passwordStrength: '',
        },
        updateMessageInfo: '',
        pswSetInfo: {},
        alertDesc: '',
        safeSetInfo: {},
        passwordRules: '',
        ssoParams: {},
        isHB: process.env.VUE_APP_ISHB == 1,
        isNative: false,
      }
    },
    created() {
      const { appid, msgSignature, timeStamp, nonce, encrypt } = this.$route.query
      this.ssoParams = { appid, msgSignature, timeStamp, nonce, encrypt }
      if (this.isHB && validateObject(this.ssoParams)) {
        this.isNative = true
      }
      this.getPswSet()
      if (this.$route.path == '/mupdatePassword') {
        // 登录之前的修改密码页面
        let safeSetInfo = sessionStorage.getItem('SAFE_SET_INFO')
        this.safeSetInfo = safeSetInfo ? JSON.parse(safeSetInfo) : {}

        // 判断是否浏览器回退前进进入
        let before_login = JSON.parse(sessionStorage.getItem('BEFORE_LOGIN'))
        if (!before_login || before_login.editPwd == '-1') {
          this.$router.replace({ path: '/mlogin' })
        } else {
          this.before_login = { ...before_login }
          let editPwd = before_login.editPwd
          if (editPwd == 1) {
            this.updateMessageInfo = this.$t('base.password.init_error')
          } else if (editPwd == 2) {
            this.updateMessageInfo = this.$t(
              'base.password.overtime_error'
            ).replace('$xxx', this.safeSetInfo.dqxgmmts)
          } else {
            this.updateMessageInfo = this.$t('base.password.strength_error')
          }
        }
      }
    },
    watch: {
      pswSetInfo: {
        deep: true,
        handler(n, o) {
          let obj = { ...n }
          if (obj.mmcl == 1) {
            this.passwordRules = `<div>${this.$t(
              'base.password.weak_password'
            )}${this.$t('base.punctuation.colon')}${this.$t(
              'base.password.length_tip'
            )}${this.$t('base.punctuation.colon')}${obj.zlrmmgzcd}${this.$t(
              'base.punctuation.comma'
            )}${this.$t('base.password.least_includes_tip')}${this.$t(
              'base.punctuation.colon'
            )}${obj.zlrmmgzsl}</div>
            <div>${this.$t('base.password.medium_password')}${this.$t(
              'base.punctuation.colon'
            )}${this.$t('base.password.length_tip')}${this.$t(
              'base.punctuation.colon'
            )}${obj.zlzmmgzcd}${this.$t('base.punctuation.comma')}${this.$t(
              'base.password.least_includes_tip'
            )}${this.$t('base.punctuation.colon')}${obj.zlzmmgzsl}</div>
            <div>${this.$t('base.password.strong_password')}${this.$t(
              'base.punctuation.colon'
            )}${this.$t('base.password.length_tip')}${this.$t(
              'base.punctuation.colon'
            )}${obj.zlqmmgzcd}${this.$t('base.punctuation.comma')}${this.$t(
              'base.password.least_includes_tip'
            )}${this.$t('base.punctuation.colon')}${obj.zlqmmgzsl}</div>`
          } else {
            this.passwordRules = `<div>${this.$t(
              'base.password.weak_password'
            )}${this.$t('base.punctuation.colon')}${this.$t(
              'base.password.length_tip'
            )}${this.$t('base.punctuation.colon')}${obj.tjrmmgzcd}${this.$t(
              'base.punctuation.comma'
            )}${this.$t('base.password.must_includes_tip')}${this.formatterClass(
              obj.tjrmmgzbh
            )}</div>
            <div>${this.$t('base.password.medium_password')}${this.$t(
              'base.punctuation.colon'
            )}${this.$t('base.password.length_tip')}${this.$t(
              'base.punctuation.colon'
            )}${obj.tjzmmgzcd}${this.$t('base.punctuation.comma')}${this.$t(
              'base.password.must_includes_tip'
            )}${this.formatterClass(obj.tjzmmgzbh)}</div>
            <div>${this.$t('base.password.strong_password')}${this.$t(
              'base.punctuation.colon'
            )}${this.$t('base.password.length_tip')}${this.$t(
              'base.punctuation.colon'
            )}${obj.tjqmmgzcd}${this.$t('base.punctuation.comma')}${this.$t(
              'base.password.must_includes_tip'
            )}${this.formatterClass(obj.tjqmmgzbh)}</div>`
          }
        },
      },
    },
    methods: {
      // 种类返回汉字
      formatterClass(str) {
        let arr = str.split(',')
        let list = [
          this.$t('base.password.capital'),
          this.$t('base.password.lowercase'),
          this.$t('base.password.number'),
          this.$t('base.password.character'),
        ]
        let htmlArr = []
        for (let i = 0; i < arr.length; i++) {
          htmlArr.push(list[arr[i] - 1])
        }
        return htmlArr.join('、')
      },
      // 获取密码策略
      async getPswSet() {
        const { code, data, message } = await commonAPI.getAction(
          'setting/pass/get'
        )
        if (code == 0) {
          this.pswSetInfo = { ...data }
          this.alertDesc = `${this.$t('base.password.update_alert')}${[
            '',
            this.$t('base.password.strength_weak'),
            this.$t('base.password.strength_medium'),
            this.$t('base.password.strength_strong'),
          ][this.pswSetInfo.bmz]
            }`
        } else {
          toast(message)
        }
      },

      handlePass(value) {
        let reg1 = escape(value).includes('%u') // 是否包含中文字符、汉字
        let reg2 = new RegExp(/\s+/g) // 是否包含空格
        if (reg1 || reg2.test(value)) {
          return false
        }
        return true
      },
      // 校验2次密码是否一样
      handleSurePass(val) {
        this.handleStrength(this.form.password)
        return val == this.form.password
      },

      onSubmit(values) {
        let obj = this.pswSetInfo
        if (this.$route.path == '/mupdatePassword') {
          // 登录后强制修改密码页面
          if (this.form.passwordStrength < obj.bmz) {
            toast(this.$t('base.password.update_error'))
            return
          }
        } else {
          if (this.form.passwordStrength < 1) {
            toast(this.$t('base.password.update_error'))
            return
          }
        }

        // 验证通过后更换密码
        this.updatePassApi()
      },
      // 修改密码方法
      async updatePassApi() {
        const params = !this.isNative
          ? { username: this.user.username, ...this.form }
          : { ...this.ssoParams, ...this.form }
        const url = !this.isNative
          ? '/config/changePassword'
          : '/config/changePasswordFor360app'
        const { code, message } = await commonAPI.postAction(url, params)
        if (code == 0) {
          toast(message)
          let language = localStorage.getItem('language')
          localStorage.clear()
          if (language) {
            localStorage.setItem('language', language)
          }
          if (this.isNative) {
            setTimeout(() => {
              cc.biz.navigation.close()
            }, 2000)
          } else {
            this.$router.replace({ path: '/mlogin' })
          }
        } else {
          toast(message)
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import '~@/assets/scss/base.scss';

  .box {
    height: 100vh;

    .flex {
      display: flex;
      align-items: center;
    }

    .box-title {
      background: #fff8ee;
      border: 1px solid rgba(255, 152, 0, 0.19);
      color: #ff9800;
      font-size: 14px;
      line-height: 20px;
      text-align: left;
      padding: 5px;
    }

    .img {
      width: 28vw;
      height: 36px;
    }

    .rules {
      margin-top: 10px;
      @extend .box-title;
    }
  }
</style>